import {message} from 'antd';
import {BASE_URL, api} from '../config';
import {flattenAnalysePayload} from "../Scenes/workspace/utils";
import i18n from "../i18n";
import { authFetch } from "../utils/authFetch";
import { normalizeMetadataDraft, serializeMetadataListForApi } from "../utils/metadataNormalizer";

const CREATE_ANALYSE_FULL = BASE_URL + "analyses/full";
const SUMMARY_ANALYSES = BASE_URL + "analyses/summary";
const DELETE_ANALYSE = BASE_URL + 'analyses/'
const GET_ANALYSE_FULL = BASE_URL + "analyses/";
const UPDATE_ANALYSE_FULL = BASE_URL + "analyses/";
const CREATE_ANALYSE_WITH_UPLOAD = BASE_URL + "analyses/create-with-upload";

const toMetadataCsv = (value) => {
    return serializeMetadataListForApi(value);
};

const toNullableMetadataValue = (value) => value ?? null;

const normalizeMetadataUpdatePayload = (payload = {}) => {
    const normalized = normalizeMetadataDraft(payload, { strict: true });
    return {
        context: toNullableMetadataValue(normalized.context),
        document_type: toNullableMetadataValue(normalized.document_type),
        party_role: toNullableMetadataValue(normalized.party_role),
        studied_party_name: toNullableMetadataValue(normalized.studied_party_name),
        industry: toNullableMetadataValue(toMetadataCsv(normalized.industry)),
        jurisdiction: toNullableMetadataValue(toMetadataCsv(normalized.jurisdiction)),
    };
};

export function create_analyse_with_upload(file, metadataDraft) {
    const fd = new FormData();
    const normalizedMetadata = normalizeMetadataDraft(metadataDraft, { strict: true });

    // 1) fichier
    fd.append("uploaded_file", file);

    // 2) strings: toujours envoyer une string (même vide)
    fd.append("context", normalizedMetadata.context ?? "");
    fd.append("document_type", normalizedMetadata.document_type ?? "");
    fd.append("party_role", normalizedMetadata.party_role ?? "");

    // 3) arrays: toujours envoyer du JSON array (même vide)
    const industry = normalizedMetadata.industry;
    const jurisdiction = normalizedMetadata.jurisdiction;

    fd.append("industry", JSON.stringify(industry));
    fd.append("jurisdiction", JSON.stringify(jurisdiction));

    return api
        .post(CREATE_ANALYSE_WITH_UPLOAD, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
            // Retourne la réponse brute pour laisser l'action l'extraire
            return res?.data;
        })
        .catch((error) => {
            message.error(i18n.t("review:messages.apiCreateUploadError") + ": " + (error?.response?.data?.detail ?? error.message));
            throw error;
        });
}

export function updateAnalyseMetadata(id, payload) {
    return api
        .put(`${UPDATE_ANALYSE_FULL}${id}/metadata`, normalizeMetadataUpdatePayload(payload))
        .then(res => res.data)
        .catch(err => {
            message.error(i18n.t("review:messages.apiUpdateMetadataError") + ": " + err.message);
            throw err;
        });
}
export function guessAnalyseMetadata(id, payload) {
    return api
        .post(`${UPDATE_ANALYSE_FULL}${id}/metadata/guess`, payload)
        .then(res => res.data)
        .catch(err => {
            message.error(i18n.t("review:messages.apiGuessMetadataError", { defaultValue: "Erreur lors de la suggestion IA" }) + ": " + err.message);
            throw err;
        });
}
/**
 * POST /api/ia-review-results/{ai_comment_id}/enrichment/stream
 * Déclenche l'enrichissement "Lire" d'un commentaire via Archimède.
 * Retourne un SSE unique: data: {"event":"card_enrichment","id":"...","detailed_view":{...}}
 * Cache géré côté frontend (AICommentSidebar.enrichmentById).
 *
 * @param {string} ai_comment_id - UUID du commentaire IA
 * @param {object} [options]
 * @param {AbortSignal} [options.signal] - Signal pour annuler la requête (timeout / unmount)
 */
export function stream_comment_enrichment(ai_comment_id, { signal } = {}) {
    return authFetch(
        BASE_URL + `ia-review-results/${ai_comment_id}/enrichment/stream`,
        {
            method: "POST",
            headers: {
                Accept: "text/event-stream",
                "Content-Type": "application/json",
            },
            ...(signal ? { signal } : {}),
        }
    );
}

export function create_analyse_full(data) {
    const flat = flattenAnalysePayload(data)
    return api
        .post(CREATE_ANALYSE_FULL, flat)
        .then(res => res.data)
        .catch(error => {
            message.error(i18n.t("review:messages.apiAnalyseFullError") + ": " + error.message)
            throw error
        })
}

export function fetchAnalysesSummary() {
    return api
        .get(SUMMARY_ANALYSES)
        .then(res => res.data)
        .catch(error => {
            message.error(i18n.t("review:messages.apiFetchSummaryError") + ": " + error.message);
            throw error;
        });
}

export function deleteAnalyse(id) {
    return api
        .delete(`${DELETE_ANALYSE}${id}`)
        .then(res => res.data)
        .catch(err => {
            message.error(i18n.t("review:messages.apiDeleteAnalyseError") + ": " + err.message)
            throw err
        })
}

export function getAnalyseFull(id) {
    return api
        .get(`${GET_ANALYSE_FULL}${id}/full`)
        .then(res => res.data)
        .catch(err => {
            message.error(i18n.t("review:messages.apiGetAnalyseError") + ": " + err.message);
            throw err;
        });
}

export function updateAnalyseFull(id, payload) {
    const flat = flattenAnalysePayload(payload)
    return api
        .put(`${UPDATE_ANALYSE_FULL}${id}/full`, flat)
        .then(res => res.data)
        .catch(err => {
            message.error(i18n.t("review:messages.apiUpdateAnalyseError") + ": " + err.message);
            throw err;
        });
}

